import Vue from 'vue';
import {FormField} from "../components/FormField";
import {ErrorBag, Validator} from "../components/Validator";
import * as yup from 'yup';

new Vue({
    el: '#wholesale-form',
    data() {
        return {
            sended: false,
            errors: new ErrorBag(),
            body: '',
            email: '',
            marketing: false
        }
    },
    components: {
        FormField
    },
    mounted() {
        this.validator = new Validator(
            yup.object()
                .shape({
                    email: yup.string()
                        .required('Podaj adres e-mail')
                        .email('Podaj poprawny adres e-mail'),
                    body: yup.string()
                        .required('Podaj treść wiadomości'),
                    marketing: yup.boolean()
                        .test(
                            'is-checked',
                            'Zgoda na kontakt jest wymagana',
                            value => !!value,
                        )
                })
        );
        
        if (typeof result !== 'undefined' && result === 'success') {
            this.sended = true;
            
            setTimeout(() => {
                this.sended = false;
            }, 4500);
        }
        
        this.errors = this.validator.errors;
        $('.show_more').click(function() {
            $(this).hide();
            $(this).prev().show();
        });
    },
    computed: {
        value() {
            return {
                email: this.email,
                body: this.body,
                marketing: this.marketing
            }
        }
    },
    methods: {
        validateField(name) {
            this.validator.validateField(name, this.value);
        },
        submit(e) {
            e.preventDefault();
            this.validator.validate(this.value)
                .then(isValid => {
                    if (isValid) {
                        this.$el.submit();
                    }
                });
        }
    }
});
